document.addEventListener('DOMContentLoaded', () => {
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const menuButtons = document.querySelectorAll('[data-menu-toggle]');

  const setMenu = (open) => {
    if (!mobileNav) return;
    mobileNav.setAttribute('data-open', String(open));
    menuButtons.forEach((button) => {
      button.setAttribute('aria-expanded', String(open));
      button.textContent = open ? 'Close' : 'Menu';
    });
  };

  menuButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const open = mobileNav?.getAttribute('data-open') === 'true';
      setMenu(!open);
    });
  });

  mobileNav?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setMenu(false));
  });

  document.querySelectorAll('[data-store-back]').forEach((button) => {
    button.addEventListener('click', () => {
      if (window.history.length > 1) window.history.back();
      else window.location.href = '/';
    });
  });

  document.querySelectorAll('[data-media-gallery]').forEach((gallery) => {
    const slides = Array.from(gallery.querySelectorAll('[data-media-slide]'));
    const thumbnails = Array.from(gallery.querySelectorAll('[data-media-target]'));

    const showMedia = (id) => {
      slides.forEach((slide) => {
        const active = slide.dataset.mediaSlide === id;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        if (!active) {
          slide.querySelectorAll('video').forEach((video) => video.pause());
        }
      });
      thumbnails.forEach((thumbnail) => {
        const active = thumbnail.dataset.mediaTarget === id;
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-current', String(active));
      });
    };

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => showMedia(thumbnail.dataset.mediaTarget));
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const form = select.closest('form');
    const details = select.closest('.product-details');
    const price = details?.querySelector('[data-product-price]');
    const button = form?.querySelector('[data-add-to-cart]');
    const buttonText = form?.querySelector('[data-add-to-cart-text]');

    const updateVariant = () => {
      const option = select.options[select.selectedIndex];
      const available = option?.dataset.available === 'true';
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (button) button.disabled = !available;
      if (buttonText) buttonText.textContent = available ? 'Add to cart' : 'Sold out';
    };

    select.addEventListener('change', updateVariant);
    updateVariant();
  });

  const teaserPageUrl = '/pages/book-teasers';

  const desktopNav = document.querySelector('.nav');
  if (desktopNav && !desktopNav.querySelector(`a[href="${teaserPageUrl}"]`)) {
    const teaserItem = document.createElement('div');
    teaserItem.className = 'nav-item';
    teaserItem.innerHTML = `<a href="${teaserPageUrl}">Teasers</a>`;
    const posterItem = Array.from(desktopNav.children).find((item) => item.querySelector('a[href="/collections/posters-prints"]'));
    desktopNav.insertBefore(teaserItem, posterItem || null);
  }

  if (mobileNav && !mobileNav.querySelector(`a[href="${teaserPageUrl}"]`)) {
    const teaserGroup = document.createElement('div');
    teaserGroup.className = 'mobile-nav-group';
    teaserGroup.innerHTML = `<a href="${teaserPageUrl}">Book Teasers</a>`;
    const posterLink = mobileNav.querySelector('a[href="/collections/posters-prints"]');
    const posterGroup = posterLink?.closest('.mobile-nav-group') || posterLink;
    mobileNav.insertBefore(teaserGroup, posterGroup || null);
    teaserGroup.querySelector('a')?.addEventListener('click', () => setMenu(false));
  }

  const pathGrid = document.querySelector('.path-grid');
  if (pathGrid && !pathGrid.querySelector(`a[href="${teaserPageUrl}"]`)) {
    const teaserPath = document.createElement('a');
    teaserPath.className = 'path-card';
    teaserPath.href = teaserPageUrl;
    teaserPath.innerHTML = '<span class="path-number">04</span><h3>Book Teasers</h3><p>Watch both teaser versions for every available title in one dedicated video library.</p><span class="card-action">Watch the teasers →</span>';
    pathGrid.appendChild(teaserPath);
  }

  const featuredTeaserCopy = document.querySelector('.teaser-feature .teaser-copy');
  const featuredTeaserButton = featuredTeaserCopy?.querySelector('a.button.primary');
  if (featuredTeaserCopy && featuredTeaserButton) {
    const posterUrl = featuredTeaserButton.dataset.posterUrl || '/products/the-glass-playground-cover-poster';
    featuredTeaserButton.href = `${teaserPageUrl}#the-glass-playground`;
    featuredTeaserButton.textContent = 'Watch both teasers';

    let actions = featuredTeaserCopy.querySelector('.teaser-home-actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'button-row compact-buttons teaser-home-actions';
      featuredTeaserButton.parentNode.insertBefore(actions, featuredTeaserButton);
      actions.appendChild(featuredTeaserButton);
    }

    if (posterUrl && !actions.querySelector('[data-featured-poster-link]')) {
      const posterLink = document.createElement('a');
      posterLink.className = 'button secondary';
      posterLink.href = posterUrl;
      posterLink.textContent = 'View the poster';
      posterLink.setAttribute('data-featured-poster-link', 'true');
      actions.appendChild(posterLink);
    }
  }

  document.addEventListener('play', (event) => {
    if (!(event.target instanceof HTMLVideoElement)) return;
    document.querySelectorAll('video').forEach((video) => {
      if (video !== event.target) video.pause();
    });
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenu(false);
  });
});
